import { useRef, useState, useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import DefaultLayout from '../../layout/DefaultLayout/DefaultLayout';
import emailjs from '@emailjs/browser';
import './Contact.scss';

function Contact() {
  const [values, setValues] = useState({});
  const form = useRef();
  let { languageIndex } = useContext(LanguageContext);

  function handleChange({ target: { name, value } }){
      setValues(({ ...values, [name]: value }))
  }

  function sendEmail(event){
    event.preventDefault();

    emailjs.sendForm('service_p7jgc52', 'template_lspqq5s', form.current , 'IJ5WKJ4O3z_S7fQrw')
        .then((result) => {
            alert("Mensagem enviada com suceeso, entraremos em contato");
        }, (error) => {
            window.alert(error.text);
        });
        event.target.reset();
  }

  return (
    <DefaultLayout>
      <form className='contact-form' ref={form} onSubmit={sendEmail} >
        <h2>{ !languageIndex ? 'Entre em contato' : 'Get in touch'}</h2>
        <input type="text" placeholder={ !languageIndex ? 'Nome' : 'Name'}  name='name' onChange={handleChange} required/>
        <input type="email" placeholder='Email'  name='email' onChange={handleChange} required/>
        <input type="text" placeholder={ !languageIndex ? 'Telefone' : 'Phone number'}  name='phone' onChange={handleChange} required/>
        <input type="text" placeholder={ !languageIndex ? 'Assunto' : 'Subject'}  name='subject' onChange={handleChange} required/>
        <textarea placeholder={ !languageIndex ? 'Digite sua mensagem aqui' : 'Type your message here'}  name='message' onChange={handleChange} required/>
        <button type='submit'>{ !languageIndex ? 'Enviar' : 'Send'}</button>
      </form>
    </DefaultLayout>
  )
}

export default Contact;